"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamQuoteLinkProperty = exports.teamQuoteLinkPropertyDefinition = void 0;
exports.teamQuoteLinkPropertyDefinition = {
    view: {
        label: 'Athlete Link',
        hint: 'Link quote to an athlete. Remove the link again to add a freetext quote author instead.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['athlete'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'team-quote-link',
};
const isTeamQuoteLinkProperty = (prop) => {
    return prop.name === exports.teamQuoteLinkPropertyDefinition.name;
};
exports.isTeamQuoteLinkProperty = isTeamQuoteLinkProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhbS1xdW90ZS1saW5rLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGVhbS1xdW90ZS1saW5rLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsK0JBQStCLEdBQUc7SUFDN0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsSUFBSSxFQUFFLHlGQUF5RjtLQUNoRztJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsU0FBUyxDQUFDO1NBQ3RCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGlCQUFpQjtDQUNRLENBQUE7QUFJMUIsTUFBTSx1QkFBdUIsR0FBRyxDQUFDLElBQWtCLEVBQWlDLEVBQUU7SUFDM0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHVDQUErQixDQUFDLElBQUksQ0FBQTtBQUMzRCxDQUFDLENBQUE7QUFGWSxRQUFBLHVCQUF1QiwyQkFFbkMifQ==